export default "__VITE_ASSET__5d149b6a__"